import React, {useEffect, useRef, useState} from 'react';
import "./TextEntry.sass";
import renderHTML from 'react-render-html';
import apiJSON from "../../../api/apiJSON";
import StandardButton from "../../ui/Button/StandardButton";
import {useReactToPrint} from "react-to-print";
import EnhancedPopUp from "../../ui/PopUp/EnhancedPopUp";
import TextEntryPrintScreen from "./TextEntryPrintScreen";

const TextEntry = ({data, completed, next}) => {

    const [feedback, setFeedback] = useState(null);
    const [showInstructions, setShowInstructions] = useState(true);
    const [entry, setEntry] = useState("");
    const textArea = useRef(null);
    const [printData, setPrintData] = useState(null)
    const jsonData = apiJSON.get(data);
    const componentRef = useRef();


    useEffect(() => {
        if(entry.length>=1&&printData){
            setPrintData({...printData, entry: entry, title:jsonData.title})
        }
    }, [entry]);

    const handleSubmit = () => {
        setFeedback(jsonData.feedback)
    }

    const finished = () => {
        setPrintData({...printData, entry: entry, title:jsonData.title})
        completed();
    };

    const handleContinue = () => {
        setFeedback(null);
        finished();
    }

    const updateEntry = () => {
        setEntry(textArea.current.value);
    }

    const focusTextArea = () => {
        setShowInstructions(false);
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    return (
        <div className="TextEntry">
            <div className="textentry-printscreen-wrapper">
                <TextEntryPrintScreen ref={componentRef}
                                      data={printData}/>
            </div>
            {feedback ? (
                <EnhancedPopUp data={feedback}
                               onHide={handleContinue}/>
            ) : null}
            <div className="textentry-title">
                {jsonData.title}
            </div>
            <div className="textentry-body">
                {renderHTML(jsonData.body)}
            </div>

            <div id="textentry-area"
                 className="textentry-area">
                    <textarea
                        ref={textArea}
                        type="text"
                        className="textentry-input"
                        onChange={updateEntry}
                        onClick={focusTextArea}/>
                {showInstructions ? (<div className="entry-instructions">
                    {renderHTML(jsonData.instructions)}
                </div>) : null}
            </div>
            <div className="textentry-button-row">
                <StandardButton data={"SUBMIT"}
                                disabled={!(entry.toString().length > 1)}
                                callback={handleSubmit}/>
                <StandardButton data={"print"}
                                disabled={!printData}
                                callback={handlePrint}/>
            </div>


        </div>
    );
};

export default TextEntry;